import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.scss';

const Flash = ({ messages }) => {
  const messageEntry = (type) => {
    const entry = (
      <div className={`${styles.alert} ${styles[type]}`} key={type}>
        <div className={styles.alertMessage} data-testid="flash-message">
          {messages[type]}
        </div>
      </div>
    );
    return entry;
  };

  const messageEntries = () => {
    const msgsArray = [];
    if (messages.error) {
      msgsArray.push(messageEntry('error'));
    }
    if (messages.notice) {
      msgsArray.push(messageEntry('notice'));
    }
    if (messages.warning) {
      msgsArray.push(messageEntry('warning'));
    }
    if (messages.success) {
      msgsArray.push(messageEntry('success'));
    }
    if (messages.info) {
      msgsArray.push(messageEntry('info'));
    }
    return msgsArray;
  };

  const hasMessages =
    messages &&
    (messages.error ||
      messages.notice ||
      messages.warning ||
      messages.success ||
      messages.info);

  return hasMessages ? (
    <div className={styles.messages}>{messageEntries()}</div>
  ) : null;
};

Flash.defaultProps = {
  messages: null
};

Flash.propTypes = {
  messages: PropTypes.shape({
    error: PropTypes.string,
    notice: PropTypes.string,
    warning: PropTypes.string,
    success: PropTypes.string,
    info: PropTypes.string
  })
};

export default Flash;
